import { useNavigate } from "react-router-dom"

import Style from "./style"
import check from "./asset/check.svg"
import checked from "./asset/checked.svg"

import MainHeader from "widget/MainHeader"

import useGetMyFranchise from "entity/franchise/useGetMyFranchise"
import usePutStoreManagerApprove from "entity/store/usePutStoreManagerApprove"
import useDeleteStoreManagerApprove from "entity/store/useDeleteStoreManagerApprove"

import DTStyle from "shared/style/detailTableStyle"
import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"

const MyFranchise = () => {
    const navigate = useNavigate()

    const [myFranchiseData] = useGetMyFranchise()
    const [approveManager] = usePutStoreManagerApprove()
    const [unapproveManager] = useDeleteStoreManagerApprove()
    const isFranchiseOwner = myFranchiseData?.data?.franchise_manager?.is_mine

    const btnList = []
    isFranchiseOwner && btnList.push({
        "label": "프렌차이즈 정보 수정",
        "clickEvent": () => navigate("/manager/my/edit"),
        "deactive": false
    })
    const myDataList = [
        {
            "label": "IDX",
            "value": myFranchiseData?.data?.franchise_manager?.idx
        },
        {
            "label": "상태",
            "value": myFranchiseData?.data?.franchise_manager?.is_approve ? "승인" : "미승인"
        },
        {
            "label": "이름",
            "value": myFranchiseData?.data?.franchise_manager?.name
        },
        {
            "label": "연락처",
            "value": myFranchiseData?.data?.franchise_manager?.contact
        },
        {
            "label": "가입 날짜",
            "value": timestampCalculator(myFranchiseData?.data?.franchise_manager?.created_at)
        },
    ]
    const myFranchiseDataList = [
        {
            "label": "IDX",
            "value": myFranchiseData?.data?.franchise_manager?.franchise_idx
        },
        {
            "label": "대표 주소",
            "value": myFranchiseData?.data?.franchise_manager?.franchise_address
        },
        {
            "label": "이름",
            "value": myFranchiseData?.data?.franchise_manager?.franchise_name
        },
        {
            "label": "대표 연락처",
            "value": myFranchiseData?.data?.franchise_manager?.franchise_contact
        },
        {
            "label": "매장 이용권",
            "value": myFranchiseData?.data?.franchise_manager?.store_ticket_name
        },
    ]
    const logoImg = myFranchiseData?.data?.franchise_manager?.franchise_logo_img

    const sizeList = ["short", "long", "long", "expand", isFranchiseOwner ? "short" : "medium", "long"]
    const tableHeadList = ["IDX", "매니저 이름", "매니저 연락처", "매장 이름", isFranchiseOwner ? "승인" : "상태", "가입 날짜"]

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList}>프렌차이즈</MainHeader>

            {!isFranchiseOwner &&
                <Style.AreaDiv>
                    <h2>프렌차이즈 매니저 정보</h2>
                    <DTStyle.TableDiv>
                        {myDataList?.map(elem =>
                            <DTStyle.TableElement>
                                <h2>{elem?.label}</h2>
                                <p>{elem?.value}</p>
                            </DTStyle.TableElement>
                        )}
                    </DTStyle.TableDiv>
                </Style.AreaDiv>
            }

            <Style.AreaDiv>
                <h2>{isFranchiseOwner ? "내" : ""} 프렌차이즈 정보</h2>
                <DTStyle.TableDiv>
                    {myFranchiseDataList?.map(elem =>
                        <DTStyle.TableElement>
                            <h2>{elem?.label}</h2>
                            <p>{elem?.value}</p>
                        </DTStyle.TableElement>
                    )}
                </DTStyle.TableDiv>
            </Style.AreaDiv>

            <Style.AreaDiv>
                <h2>로고 이미지</h2>
                {logoImg &&
                    <div>
                        <Style.LogoImg src={logoImg} />
                    </div>
                }
            </Style.AreaDiv>

            <Style.AreaDiv>
                <h2>매장 목록</h2>

                <TStyle.TableDiv>
                    <TStyle.TableRow $title>
                        {tableHeadList.map((elem, index) =>
                            <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                        )}
                    </TStyle.TableRow>
                    {myFranchiseData?.data?.store_list?.map((elem, index) =>
                        <TStyle.TableRow $odd={index % 2 === 1} onClick={() => isFranchiseOwner && navigate(`/manager/store/${elem?.idx}/detail`)}>
                            <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                            <TStyle.Data $size={sizeList[1]}>{elem?.name}</TStyle.Data>
                            <TStyle.Data $size={sizeList[2]}>{elem?.contact}</TStyle.Data>
                            <TStyle.Data $size={sizeList[3]}>{elem?.store_name}</TStyle.Data>

                            {elem?.is_mine
                                ? <TStyle.Data $size={sizeList[4]}>내 매장</TStyle.Data>
                                : isFranchiseOwner
                                    ? <TStyle.Data $size={sizeList[4]} onClick={(e) => elem?.is_approve ? unapproveManager(e, elem?.idx) : approveManager(e, elem?.idx)}>
                                        <Style.Radio><img src={elem?.is_approve ? checked : check} /></Style.Radio>
                                    </TStyle.Data>
                                    : <TStyle.Data $size={sizeList[4]}>{elem?.is_approve ? "승인" : "미승인"}</TStyle.Data>
                            }

                            <TStyle.Data $size={sizeList[5]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                        </TStyle.TableRow>
                    )}
                </TStyle.TableDiv>
            </Style.AreaDiv>

        </Style.Wrapper >
    )
}

export default MyFranchise